import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import dataEN from "./Locale/En.json";
import dataAR from "./Locale/Ar.json";
import Cookies from "js-cookie";

const resources = {
  en: {
    translation: dataEN,
  },
  ar: {
    translation: dataAR,
  },
};
const savedLanguage = Cookies.get("lng") || "en";
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on("languageChanged", (lng) => {
  Cookies.set("lng", lng, {
    expires: 7,
    path: "/",
    secure: true,
    sameSite: "Strict",
  });
});

export default i18n;
